function mockHpProposal(price) {
  return {
    proposalId: Number(20202),
    lenderReference: 'DUMMY_REF',
    isPrime: false,
    isPreferredAcceptance: true,
    minVehicleAgeAtStart: null,
    maxVehicleAgeAtStart: 12,
    maxVehicleAgeAtEnd: 15,
    minMileage: null,
    maxMileage: Number(120000),
    maxLendAmount: Number(1000000),
    minLendAmount: Number(2000),
    minTerm: Number(24),
    maxTerm: Number(60),
    loanProposalStatus: "ProvisionalAcceptance",
    amountToFinance: Number(price),
    apr: null,
    flatRate: null,

    financeCompany: 'Carfinance247',
    financeCompanyId: 49,
    tierId: 0,

    rank: null,
  }
}

module.exports = {
  mockHpProposal
};